import * as amplify from "../util/amplify.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import ApiServer from "../ApiServer.ts";
import * as Storage from "../lib/Storage.ts";

import TPL_wall from "../feed/wall.mustache";
import TPL_wallempty from "../feed/empty.mustache";
import TPL_feed from "../feed/feed.mustache";
import TPL_default from "../feed/default.mustache";

Html.registerWidget('widget/wall',{initDom,destroyDom})

  var
    // Private fields

    // string, name of currently selected filter
    // corresponding to a data-fw-filter attribute on activity filter menu
    selectedActivityFilter = "all",
    selectedSortBy = Storage.localGet("wallsortby"),
    selectedMemberFilter = "all",
    ASKED_COUNT = 10,
    // string, sorting date of the most recent activity displayed
    newestActivitySortingDate = new Date(0),

    // string, id of the latest activity displayed
    oldestActivityId,

    // HTMLElement wrapping the list of activities
    feedList: HTMLElement = null,
    pollingInterval;


  /*
    Function: getFilterByType()
    Get the filter by type of activity using the selected value of filter list

    Returns:
      array, the list of activity types for selected filter
  */
  function getFilterByType(){
    switch( selectedActivityFilter ){
      case "status":
        return ["STATUS"];
      case "checkins":
        return ["PLACE_IN","PLACE_OUT"];
      case "events":
        return [
          "EVENT",
          "EVENT_CREATED","EVENT_UPDATED",/*"EVENT_DELETED",*/
          "EVENT_COMMENTED"
        ];
      case "tasks":
        return [
          "TASKLIST",
          "TASK_CREATED","TASK_UPDATED","TASK_COMMENTED","TASK_ASSIGNED","TASK_MARKED_COMPLETED"
        ];
      case "pictures":
        // Note: multiple pictures may be attached in a STATUS (or none)
        return [/*'STATUS',*/'SINGLE_PICTURE','MULTIPLE_PICTURE'];
      default: // all supported types
        return [
          "PLACE_IN","PLACE_OUT",
          "EVENT",
          "EVENT_CREATED","EVENT_UPDATED",/*"EVENT_DELETED",*/
          "EVENT_COMMENTED",
          "STATUS","SINGLE_PICTURE","MULTIPLE_PICTURE",
          "FAMILY_CREATED"/*,"INVITATION_SENT" */,"MEMBER_JOIN",
          "PROFILE_CHANGED",
          "TASKLIST",
          "TASK_CREATED","TASK_UPDATED","TASK_COMMENTED","TASK_ASSIGNED","TASK_MARKED_COMPLETED",
          // Disabled for now - cf Redmine #3782
          //"CONTACT_CREATED","CONTACT_UPDATED",
          //"CONTACT_DELETED","CONTACTS_DELETED"
        ];
    }
  }

  /*
    Function: loadNewActivities()
    Request new activities and display them at the start of the list
  */
  function loadNewActivities(){
    ApiServer.wallget({
      date: new Date(newestActivitySortingDate.getTime()+1000),
      nested:true,
      type: getFilterByType(),
      sortBy: selectedSortBy,
      accountId:selectedMemberFilter==='all'?undefined:selectedMemberFilter
    },function(feed){
      if (feed.length === 0 ){
        // no new activity
        return;
      }

        //refresh profile if new items because it might be "toto has joined family"
        ApiServer.prfgetProfiles(function(profiles) {
          FwDatas.setProfiles(profiles);

          newestActivitySortingDate = feed[0].sortingDate;
          //we replace all item where they are, and grep those who where nowhere
          feed = feed.filter(function(wallMessage,idx){
            var node = document.querySelector('#activity-feed div[data-fw-meta-id="'+wallMessage.metaId+'"]') as HTMLElement;
            if(node){
              //we want to keep the comment form if opened
              var form = node.querySelector('form');
              var formCopy = form?.cloneNode(true) as HTMLFormElement;
              Html.setHtml(node,TPL_default,wallMessage);
              if(formCopy){
                var newForm = node.querySelector('form');
                if(newForm) newForm.replaceWith(formCopy);
              }
              return false;
            }else{
              return true;
            }
          });
          try{
            Html.setHtmlAtStart(feedList,TPL_feed,{feed:feed});
          }catch(e){
            //certainly blow because we changed of page
          }
        })
    });
  }

  /*
    Function: displayActivities(data)
    Display one page of activities at the end of the list

    Parameter:
      data - object, the list of activities wrapped in a "feed" property
  */
  function displayActivities(feed){
      Html.setHtmlAtEndDom(feedList,TPL_wall,{feed:feed,hasMore:ASKED_COUNT===feed.length});
      if ( feed.length > 0 ){
        if ( newestActivitySortingDate<feed[0].sortingDate ){
          newestActivitySortingDate = feed[0].sortingDate;
        }
        oldestActivityId = feed[feed.length -1].wallMessageId;
        const endintoviewHandler = function(event: Event){
          (event.target as HTMLElement).remove();
          feedList.removeEventListener('endintoview', endintoviewHandler);
          loadActivities();
        };
        feedList.addEventListener('endintoview', endintoviewHandler);
      }else if(feedList.children.length===0){
        Html.setHtmlAtEndDom(feedList,TPL_wallempty,{});
      }


  }

  /*
    Function: loadActivities()
    Load one page of activities and display it at the end of the list
  */
  function loadActivities(){
    ApiServer.wallget({
      afterId: oldestActivityId,
      nested:true,
      nb:ASKED_COUNT,
      type: getFilterByType(),
      sortBy: selectedSortBy,
      accountId:selectedMemberFilter==='all'?undefined:selectedMemberFilter
    },
    displayActivities,
    function(){
      modal.alert("feedJs.loadError");
    });
  }

  /*
    Function: reloadActivityFeed()
    Reset the feed and load activities according to selected filters

    This method also restarts the timer to poll for new activities.
  */
  function reloadActivityFeed(){
    newestActivitySortingDate = new Date(0); // to omit parameter from request
    oldestActivityId = undefined; // to omit parameter from request
    feedList.innerHTML = '';
    loadActivities();
  }

  /*
    Function: onActivityFilterSelected(event)
    Callback for the selection of an activity filter

    Parameter:
      event - object, data associated with the "activityFilterSelected" event
  */
  function onActivityFilterSelected(event){
    if(event.filter){
      selectedActivityFilter = event.filter;
    }
    if(event.sortBy){
      selectedSortBy = event.sortBy;
    }

    reloadActivityFeed();
  }

  function resetUser(){
    amplify.publish("familyMemberSelected",{selected:"all"});
  }
  function resetAll(){
    selectedActivityFilter = null;
    resetUser();
  }

  function onFamilyMemberSelected(event){
    selectedMemberFilter = event.selected;
    reloadActivityFeed();
  }

function initDom(obj: HTMLElement){
  feedList = obj;
  amplify.subscribe("activityFilterSelected", onActivityFilterSelected);
  amplify.subscribe("familyMemberSelected", onFamilyMemberSelected);

  amplify.subscribe("newActivity", resetAll);
  amplify.subscribe("activityUpdated", resetUser);
  amplify.subscribe("eventCreated", resetAll);
  amplify.subscribe("eventDeleted", resetUser);
  amplify.subscribe("eventUpdated", resetUser);


  pollingInterval = setInterval(loadNewActivities, 60000);
  amplify.subscribe("pageUnload", function(){
    clearInterval(pollingInterval);
  });
  resetAll();
}

function destroyDom(obj: HTMLElement){
  amplify.unsubscribe("activityFilterSelected", onActivityFilterSelected);
  amplify.unsubscribe("familyMemberSelected", onFamilyMemberSelected);

  amplify.unsubscribe("newActivity", resetAll);
  amplify.unsubscribe("activityUpdated", resetUser);
  amplify.unsubscribe("eventCreated", resetAll);
  amplify.unsubscribe("eventDeleted", resetUser);
  amplify.unsubscribe("eventUpdated", resetUser);

  clearInterval(pollingInterval);
}
